import { render } from "./step_askfor.vue?vue&type=template&id=6f9b352a&scoped=true"
import script from "./step_askfor.vue?vue&type=script&lang=js"
export * from "./step_askfor.vue?vue&type=script&lang=js"

import "./step_askfor.vue?vue&type=style&index=0&id=6f9b352a&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9b352a"]])

export default __exports__